import React, { ReactNode } from 'react';

import { Box, Typography } from '@material-ui/core';
import clsx from 'clsx';

import { useReportStyles } from '../styles';

interface Props {
  title: string;
  description?: ReactNode;
  icon?: ReactNode;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
  className?: string;
  /** Rendered under the description, e.g. a pill or the custom-request text box. */
  children?: ReactNode;
}

/** A bordered, keyboard-reachable choice: report type, analysis, field set. */
export const ReportOptionCard: React.FC<Props> = ({
  title,
  description,
  icon,
  selected,
  disabled = false,
  onSelect,
  className,
  children,
}) => {
  const classes = useReportStyles();

  return (
    <Box
      role="radio"
      aria-checked={selected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      className={clsx(classes.optionCard, className, {
        [classes.optionCardSelected]: selected,
        [classes.optionCardDisabled]: disabled,
      })}
      onClick={disabled ? undefined : onSelect}
      onKeyDown={event => {
        if (!disabled && (event.key === 'Enter' || event.key === ' ') && event.target === event.currentTarget) {
          event.preventDefault();
          onSelect();
        }
      }}>
      {icon && <Box className={clsx(classes.optionIcon, { [classes.optionIconSelected]: selected })}>{icon}</Box>}
      <Box flex={1} minWidth={0}>
        <Typography className={classes.optionTitle}>{title}</Typography>
        {description && (
          <Typography component="div" className={classes.hint} style={{ marginTop: 2 }}>
            {description}
          </Typography>
        )}
        {children}
      </Box>
    </Box>
  );
};
